export type Theme = "light" | "dark";

export const themeColors: Record<Theme, string> = {
  light: "#f3f0e9",
  dark: "#0d0d10",
};

export function parseTheme(value: string | null | undefined): Theme | null {
  return value === "light" || value === "dark" ? value : null;
}

export function resolveTheme(stored: string | null | undefined, systemPrefersDark: boolean): Theme {
  return parseTheme(stored) ?? (systemPrefersDark ? "dark" : "light");
}
